//  hidden === true时，当前项不在菜单栏中展示
export const data = [{
  label: '个人办公',
  icon: 'compass',
  path: '/',
  component: 'Layout',
  children: [{
    label: '工作台',
    icon: '',
    path: '/',
    name: 'workbench',
    component: 'workbench/index',
    meta: {
      title: '工作台'
    }
  }, {
    label: '信息列表',
    icon: '',
    path: '/newsList',
    name: 'newsList',
    component: 'workbench/newsList',
    meta: {
      isMenuOpens: '工作台',
      title: '信息列表'
    },
    hidden: true
  }, {
    label: '信息列表',
    icon: '',
    path: '/messageCenter',
    name: 'messageCenter',
    component: 'workbench/messageCenter',
    meta: {
      isMenuOpens: '消息中心',
      title: '信息列表'
    },
    hidden: true
  }, {
    label: '公司新闻',
    icon: '',
    path: '/newsDetial',
    name: 'newsDetial',
    component: 'workbench/newsDetial',
    meta: {
      isMenuOpens: '新闻管理',
      title: '公司新闻'
    },
    hidden: true
  }, {
    label: '个人中心',
    icon: '',
    path: '/mine',
    name: 'mine',
    component: 'workbench/mine',
    meta: {
      isMenuOpens: '工作台',
      title: '个人中心'
    },
    hidden: true
  }]
}, {
  label: '人事管理',
  icon: 'user',
  path: '/roster',
  component: 'Layout',
  children: [{
    label: '人员花名册',
    icon: '',
    path: '/roster',
    name: 'roster',
    component: 'PersonnelManagement/roster',
    meta: {
      isMenuOpens: '人事管理',
      title: '人员花名册'
    },

  }, {
    label: '合同到期人员',
    icon: '',
    path: '/expireList',
    name: 'expireList',
    component: 'PersonnelManagement/expireList',
    meta: {
      isMenuOpens: '人事管理',
      title: '到期提醒'
    }
  }, {
    label: '详情页',
    icon: '',
    path: '/PersonnelDetails',
    name: 'PersonnelDetails',
    component: 'PersonnelManagement/PersonnelDetails',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '人员详细信息'
    }
  }, {
    label: '新建花名册信息',
    icon: '',
    path: '/addPersonnel',
    name: 'addPersonnel',
    component: 'PersonnelManagement/add',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '新建花名册信息'
    }
  }, {
    label: '历史查询',
    icon: '',
    path: '/AdvancedQuery',
    name: 'AdvancedQuery',
    component: 'PersonnelManagement/AdvancedQuery',
    hidden: true,
    meta: {
      isMenuOpens: '人事管理',
      title: '历史查询'
    }
  }]
}, {
  label: '专项资金申请',
  icon: 'calendar',
  path: '/MoneyToApply',
  component: 'Layout',
  children: [{
    label: '申请列表',
    icon: '',
    path: '/MoneyToApply',
    name: 'MoneyToApply',
    component: 'MoneyToApply/index',
    meta: {
      isMenuOpens: '专项资金申请',
      title: '申请列表'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/MoneyToApplyDrafts',
    name: 'MoneyToApplyDrafts',
    component: 'MoneyToApply/drafts',
    meta: {
      isMenuOpens: '专项资金申请',
      title: '草稿箱'
    }
  }, {
    label: '表单详情',
    icon: '',
    path: '/MoneyToApplyDetial',
    name: 'MoneyToApplyDetial',
    component: 'MoneyToApply/detial',
    meta: {
      isMenuOpens: '专项资金申请',
      title: '表单详情'
    },
    hidden: true
  }]
}, {
  label: '固定资产管理',
  icon: 'dollar',
  path: '/procurement',
  component: 'Layout',
  children: [{
    label: '固定资产购置申请表',
    icon: '',
    path: '/procurement',
    name: 'procurement',
    component: 'FixedAssets/procurement',
    meta: {
      isMenuOpens: '固定资产管理',
      title: '固定资产购置申请表'
    }
  },
  //  {
  //   label: '草稿箱',
  //   icon: '',
  //   path: '/drafts',
  //   name: 'drafts',
  //   component: 'FixedAssets/drafts',
  //   meta: {
  //     isMenuOpens: '固定资产管理',
  //     title: '草稿箱'
  //   }
  // }, 
  {
    label: '固定资产购置申请',
    icon: '',
    path: '/proDetial',
    name: 'proDetial',
    component: 'FixedAssets/proDetial',
    hidden: true,
    meta: {
      isMenuOpens: '固定资产管理',
      title: '固定资产购置申请'
    }
  }, {
    label: '固定资产处置审批表',
    icon: '',
    path: '/disposition',
    name: 'disposition',
    component: 'FixedAssets/disposition',
    meta: {
      isMenuOpens: '固定资产管理',
      title: '固定资产处置审批表'
    }
  },
  //  {
  //   label: '草稿箱',
  //   icon: '',
  //   path: '/disDrafts',
  //   name: 'disDrafts',
  //   component: 'FixedAssets/disDrafts',
  //   meta: {
  //     isMenuOpens: '固定资产管理',
  //     title: '草稿箱'
  //   }
  // }, 
  {
    label: '固定资产处置',
    icon: '',
    path: '/disDetial',
    name: 'disDetial',
    component: 'FixedAssets/disDetial',
    meta: {
      isMenuOpens: '固定资产管理',
      title: '固定资产处置'
    },
    hidden: true
  }]
}, {
  label: '简报',
  icon: 'calendar',
  path: '/BriefReport',
  component: 'Layout',
  children: [{
    label: '简报列表',
    icon: '',
    path: '/BriefReport',
    name: 'BriefReport',
    component: 'BriefReport/index',
    meta: {
      isMenuOpens: '简报',
      title: '简报列表'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/BriefReportDrafts',
    name: 'BriefReportDrafts',
    component: 'BriefReport/drafts',
    meta: {
      isMenuOpens: '简报',
      title: '草稿箱'
    }
  }, {
    label: '详情',
    icon: '',
    path: '/BriefReportDetial',
    name: 'BriefReportDetial',
    component: 'BriefReport/detial',
    meta: {
      isMenuOpens: '简报',
      title: '详情'
    },
    hidden: true
  }]
}, {
  label: '公文发文管理',
  icon: 'calendar',
  path: '/officialDocument',
  component: 'Layout',
  children: [{
    label: '发文列表',
    icon: '',
    path: '/officialDocument',
    name: 'officialDocument',
    component: 'OfficialDocument/index',
    meta: {
      isMenuOpens: '公文发文',
      title: '发文列表'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/OfficialDocumentDrafts',
    name: 'OfficialDocumentDrafts',
    component: 'OfficialDocument/drafts',
    meta: {
      isMenuOpens: '公文发文',
      title: '草稿箱'
    }
  }, {
    label: '公文详情',
    icon: '',
    path: '/OfficialDocumentDetial',
    name: 'OfficialDocumentDetial',
    component: 'OfficialDocument/detial',
    meta: {
      isMenuOpens: '公文发文管理',
      title: '公文详情'
    },
    hidden: true
  }]
}, {
  label: '资金支付',
  icon: 'calendar',
  path: '/FundPayment',
  component: 'Layout',
  children: [{
    label: '资金支付申请表',
    icon: '',
    path: '/FundPayment',
    name: 'FundPayment',
    component: 'FundPayment/index',
    meta: {
      isMenuOpens: '资金支付',
      title: '资金支付申请表'
    }
  }, {
    label: '资金支付申请',
    icon: '',
    path: '/FundPaymentDetial',
    name: 'FundPaymentDetial',
    component: 'FundPayment/detial',
    meta: {
      isMenuOpens: '资金支付',
      title: '资金支付申请'
    },
    hidden: true
  }, {
    label: '草稿箱',
    icon: '',
    path: '/FundPaymentDrafts',
    name: 'FundPaymentDrafts',
    component: 'FundPayment/drafts',
    meta: {
      isMenuOpens: '资金支付',
      title: '草稿箱'
    }
  }]
}, {
  label: '费用报销',
  icon: 'calendar',
  path: '/ClaimExpense',
  component: 'Layout',
  children: [{
    label: '费用报销申请表',
    icon: '',
    path: '/ClaimExpense',
    name: 'ClaimExpense',
    component: 'ClaimExpense/index',
    meta: {
      isMenuOpens: '费用报销',
      title: '费用报销申请表'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/ClaimExpenseDrafts',
    name: 'ClaimExpenseDrafts',
    component: 'ClaimExpense/drafts',
    meta: {
      isMenuOpens: '费用报销',
      title: '草稿箱'
    }
  }, {
    label: '表单详情',
    icon: '',
    path: '/ClaimExpenseDetial',
    name: 'ClaimExpenseDetial',
    component: 'ClaimExpense/detial',
    meta: {
      isMenuOpens: '费用报销',
      title: '表单详情'
    },
    hidden: true
  }]
}, {
  label: '审计报告',
  icon: 'calendar',
  path: '/standingBook',
  component: 'Layout',
  children: [{
    label: '审计报告督导台账列表',
    icon: '',
    path: '/standingBook',
    name: 'standingBook',
    component: 'standingBook/index',
    meta: {
      isMenuOpens: '审计报告',
      title: '审计报告督导台账列表'
    }
  }, {
    label: '我的整改任务',
    icon: '',
    path: '/myTask',
    name: 'myTask',
    component: 'standingBook/myTask',
    meta: {
      isMenuOpens: '审计报告',
      title: '我的整改任务'
    }
  }, {
    label: '审计报告详情',
    icon: '',
    path: '/standingBookDetails',
    name: 'standingBookDetails',
    component: 'standingBook/details',
    meta: {
      isMenuOpens: '审计报告',
      title: '审计报告详情'
    },
    hidden: true
  }, {
    label: '草稿箱',
    icon: '',
    path: '/standingBookDrafts',
    name: 'standingBookDrafts',
    component: 'standingBook/drafts',
    meta: {
      isMenuOpens: '审计报告',
      title: '草稿箱'
    }
  }]
}, {

  label: '基础信息管理',
  icon: 'calendar',
  path: '/baseInfoManagement',
  component: 'Layout',
  children: [{
    label: '车辆信息管理',
    icon: '',
    path: '/vehicleInfo',
    name: 'vehicleInfo',
    component: 'baseInfoManagement/vehicleInfo/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '车辆信息管理'
    }
  }, {
    label: '车辆信息管理',
    icon: '',
    path: '/vehicleInfoDetails',
    name: 'vehicleInfoDetails',
    component: 'baseInfoManagement/vehicleInfo/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '车辆信息管理'
    },
    hidden: true
  }, {
    label: '安保人员信息',
    icon: '',
    path: '/securityInfo',
    name: 'securityInfo',
    component: 'baseInfoManagement/securityInfo/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '安保人员信息'
    }
  }, {
    label: '安保人员信息管理',
    icon: '',
    path: '/securityInfoDetails',
    name: 'securityInfoDetails',
    component: 'baseInfoManagement/securityInfo/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '安保人员信息管理'
    },
    hidden: true
  }, {
    label: '特种设备信息锅炉',
    icon: '',
    path: '/specialEquipBoiler',
    name: 'specialEquipBoiler',
    component: 'baseInfoManagement/specialEquipBoiler/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '特种设备信息锅炉'
    }
  }, {
    label: '特种设备信息锅炉管理',
    icon: '',
    path: '/specialEquipBoilerDetails',
    name: 'specialEquipBoilerDetails',
    component: 'baseInfoManagement/specialEquipBoiler/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '特种设备信息锅炉管理'
    },
    hidden: true
  }, {
    label: '特种设备信息电梯',
    icon: '',
    path: '/specialEquipElevator',
    name: 'specialEquipElevator',
    component: 'baseInfoManagement/specialEquipElevator/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '特种设备信息电梯'
    }
  }, {
    label: '特种设备信息电梯管理',
    icon: '',
    path: '/specialEquipElevatorDetails',
    name: 'specialEquipElevatorDetails',
    component: 'baseInfoManagement/specialEquipElevator/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '特种设备信息电梯管理'
    },
    hidden: true
  }, {
    label: '防汛管理',
    icon: '',
    path: '/floodControl',
    name: 'floodControl',
    component: 'baseInfoManagement/floodControl/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '防汛管理'
    }
  }, {
    label: '防汛管理',
    icon: '',
    path: '/floodControlDetails',
    name: 'floodControlDetails',
    component: 'baseInfoManagement/floodControl/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '防汛管理'
    },
    hidden: true
  }, {
    label: '消防器材管理',
    icon: '',
    path: '/fireEquipment',
    name: 'fireEquipment',
    component: 'baseInfoManagement/fireEquipment/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '消防器材管理'
    }
  }, {
    label: '消防器材管理',
    icon: '',
    path: '/fireEquipmentDetails',
    name: 'fireEquipmentDetails',
    component: 'baseInfoManagement/fireEquipment/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '消防器材管理'
    },
    hidden: true
  }, {
    label: '食堂管理',
    icon: '',
    path: '/cantennManagement',
    name: 'cantennManagement',
    component: 'baseInfoManagement/cantennManagement/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '食堂管理'
    }
  }, {
    label: '食堂管理',
    icon: '',
    path: '/cantennMagDetails',
    name: 'cantennMagDetails',
    component: 'baseInfoManagement/cantennManagement/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '食堂管理'
    },
    hidden: true
  }, {
    label: '配电室管理',
    icon: '',
    path: '/powerDistributeRoom',
    name: 'powerDistributeRoom',
    component: 'baseInfoManagement/powerDistributeRoom/index',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '配电室管理'
    }
  }, {
    label: '配电室管理',
    icon: '',
    path: '/powerRoomDetails',
    name: 'powerRoomDetails',
    component: 'baseInfoManagement/powerDistributeRoom/details',
    meta: {
      isMenuOpens: '基础信息管理',
      title: '配电室管理'
    },
    hidden: true
  }]
}, {
  label: '专项资金自查',
  icon: 'calendar',
  path: '/SpecialFundsSelfInspection',
  component: 'Layout',
  children: [{
    label: '专项资金自查',
    icon: '',
    path: '/SpecialFundsSelfInspection',
    name: 'SpecialFundsSelfInspection',
    component: 'SpecialFundsSelfInspection/index',
    meta: {
      isMenuOpens: '专项资金自查',
      title: '专项资金自查列表'
    }
  }, {
    label: '专项资金自查信息统计',
    icon: '',
    path: '/StatisticalResult',
    name: 'StatisticalResult',
    component: 'SpecialFundsSelfInspection/StatisticalResult',
    meta: {
      isMenuOpens: '专项资金自查',
      title: '专项资金自查信息统计'
    }
  }, {
    label: '专项资金自查表单',
    icon: '',
    path: '/SpecialFundsSelfInspectionDetial',
    name: 'SpecialFundsSelfInspectionDetial',
    component: 'SpecialFundsSelfInspection/detial',
    hidden: true,
    meta: {
      isMenuOpens: '专项资金自查',
      title: '专项资金自查表单'
    }
  }]
}, {
  label: '隐患问题整改',
  icon: 'calendar',
  path: '/PotentialSafetyHazard',
  component: 'Layout',
  children: [{
    label: '隐患问题列表',
    icon: '',
    path: '/PotentialSafetyHazard',
    name: 'PotentialSafetyHazard',
    component: 'PotentialSafetyHazard/index',
    meta: {
      isMenuOpens: '隐患问题整改',
      title: '隐患问题列表'
    }
  }, {
    label: '隐患问题',
    icon: '',
    path: '/PotentialSafetyHazardDetial',
    name: 'PotentialSafetyHazardDetial',
    component: 'PotentialSafetyHazard/detial',
    meta: {
      isMenuOpens: '隐患问题整改',
      title: '表单详情'
    },
    hidden: true
  }
    // , {
    //   label: '草稿箱',
    //   icon: '',
    //   path: '/PotentialSafetyHazardDrafts',
    //   name: 'PotentialSafetyHazardDrafts',
    //   component: 'PotentialSafetyHazard/drafts',
    //   meta: {
    //     isMenuOpens: '隐患问题整改',
    //     title: '草稿箱'
    //   }
    // }
  ]
}, {
  label: '项目申请',
  icon: 'calendar',
  path: '/ProjectApplication',
  component: 'Layout',
  children: [{
    label: '项目申请',
    icon: '',
    path: '/ProjectApplication',
    name: 'ProjectApplication',
    component: 'ProjectApplication/index',
    meta: {
      isMenuOpens: '项目申请',
      title: '建设项目申请列表'
    }
  }, {
    label: '建设项目',
    icon: '',
    path: '/ProjectApplicationDetial',
    name: 'ProjectApplicationDetial',
    component: 'ProjectApplication/detial',
    meta: {
      isMenuOpens: '项目申请',
      title: '表单详情'
    },
    hidden: true
  }, {
    label: '草稿箱',
    icon: '',
    path: '/ProjectApplicationDrafts',
    name: 'ProjectApplicationDrafts',
    component: 'ProjectApplication/drafts',
    meta: {
      isMenuOpens: '项目申请',
      title: '草稿箱'
    }
  }]
}, {
  label: '通知',
  icon: 'calendar',
  path: '/InformTheForwarding',
  component: 'Layout',
  children: [{
    label: '通知转发列表',
    icon: '',
    path: '/InformTheForwarding',
    name: 'InformTheForwarding',
    component: 'InformTheForwarding/index',
    meta: {
      isMenuOpens: '纪检通知',
      title: '通知转发列表'
    }
  }, {
    label: '公文登记录入',
    icon: '',
    path: '/InformTheForwardingDetial',
    name: 'InformTheForwardingDetial',
    component: 'InformTheForwarding/detial',
    meta: {
      isMenuOpens: '纪检通知',
      title: '公文登记录入'
    },
    hidden: true
  }, {
    label: '草稿箱',
    icon: '',
    path: '/InformTheForwardingDrafts',
    name: 'InformTheForwardingDrafts',
    component: 'InformTheForwarding/drafts',
    meta: {
      isMenuOpens: '纪检通知',
      title: '关于中秋节放假的通知'
    }
  }]
}, {
  label: '退休人员',
  icon: 'calendar',
  path: '/retiree',
  component: 'Layout',
  children: [{
    label: '人员花名册',
    icon: '',
    path: '/retiree',
    name: 'retiree',
    component: 'PersonnelManagement/retiree',
    meta: {
      isMenuOpens: '退休人员',
      title: '退休人员信息查询'
    }
  }]
}, {
  label: '公务车申请',
  icon: 'calendar',
  path: '/ApplicationForVehicle',
  component: 'Layout',
  children: [{
    label: '公务车申请列表',
    icon: '',
    path: '/ApplicationForVehicle',
    name: 'ApplicationForVehicle',
    component: 'ApplicationForVehicle/index',
    meta: {
      isMenuOpens: '公务车申请管理',
      title: '公务车申请列表'
    }
  }, {
    label: '公务车用车详情',
    icon: '',
    path: '/ApplicationForVehicleDetial',
    name: 'ApplicationForVehicleDetial',
    component: 'ApplicationForVehicle/detial',
    hidden: true,
    meta: {
      isMenuOpens: '公务车申请管理',
      title: '公务车用车详情'
    }
  }]
}, {
  label: '用印管理',
  icon: 'calendar',
  path: '/ApplicationSeal',
  component: 'Layout',
  children: [{
    label: '用印申请列表',
    icon: '',
    path: '/ApplicationSeal',
    name: 'ApplicationSeal',
    component: 'ApplicationSeal/index',
    meta: {
      isMenuOpens: '用印管理',
      title: '用印申请列表'
    }
  }, {
    label: '申请使用印章',
    icon: '',
    path: '/ApplicationSealDetial',
    name: 'ApplicationSealDetial',
    component: 'ApplicationSeal/detial',
    hidden: true,
    meta: {
      isMenuOpens: '用印管理',
      title: '申请使用印章'
    }
  }]
}, {
  label: '财务信息',
  icon: 'calendar',
  path: '/FinancialInformationInquiry',
  component: 'Layout',
  children: [{
    label: '财务信息查询列表',
    icon: '',
    path: '/FinancialInformationInquiry',
    name: 'FinancialInformationInquiry',
    component: 'FinancialInformationInquiry/index',
    meta: {
      isMenuOpens: '工会财务',
      title: '财务信息查询'
    }
  },
  {
    label: '财务信息查看列表',
    icon: '',
    path: '/FinancialInformationInquiryLook',
    name: 'FinancialInformationInquiryLook',
    component: 'FinancialInformationInquiry/indexLook',
    meta: {
      isMenuOpens: '工会财务',
      title: '财务信息查看'
    }
  }]
}, {
  label: '资金支付申请管理',
  icon: 'calendar',
  path: '/ProjectFundApplication',
  component: 'Layout',
  children: [{
    label: '项目资金支付申请',
    icon: '',
    path: '/ProjectFundApplication',
    name: 'ProjectFundApplication',
    component: 'ProjectFundApplication/index',
    meta: {
      isMenuOpens: '资金支付',
      title: '项目资金支付申请'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/ProjectFundApplicationDrafts',
    name: 'ProjectFundApplicationDrafts',
    component: 'ProjectFundApplication/drafts',
    meta: {
      isMenuOpens: '资金支付',
      title: '草稿箱'
    }
  }, {
    label: '表单详情',
    icon: '',
    path: '/ProjectFundApplicationDetial',
    name: 'ProjectFundApplicationDetial',
    component: 'ProjectFundApplication/detial',
    meta: {
      isMenuOpens: '资金支付',
      title: '表单详情'
    },
    hidden: true
  }]
}, {
  label: '文章发布',
  icon: 'calendar',
  path: '/InformationPublish',
  component: 'Layout',
  children: [{
    label: '文章列表',
    icon: '',
    path: '/InformationPublish',
    name: 'InformationPublish',
    component: 'InformationPublish/index',
    meta: {
      isMenuOpens: '通知',
      title: '文章列表'
    }
  }, {
    label: '草稿箱',
    icon: '',
    path: '/InformationPublishDrafts',
    name: 'InformationPublishDrafts',
    component: 'InformationPublish/drafts',
    meta: {
      isMenuOpens: '通知',
      title: '草稿箱'
    }
  }, {
    label: '内容详情',
    icon: '',
    path: '/InformationPublishDetial',
    name: 'InformationPublishDetial',
    component: 'InformationPublish/detial',
    meta: {
      isMenuOpens: '通知',
      title: '内容详情'
    },
    hidden: true
  }]
}, {
  label: '系统管理',
  icon: 'windows',
  path: '/system',
  component: 'Layout',
  children: [{
    label: '组织机构',
    icon: '',
    path: '/InstitutionalFramework',
    name: 'InstitutionalFramework',
    component: 'system/InstitutionalFramework',
    meta: {
      isMenuOpens: '系统管理',
      title: '组织机构'
    }
  }, {
    label: '创建机构',
    icon: '',
    path: '/addInstitutionalFramework',
    name: 'addInstitutionalFramework',
    component: 'system/addInstitutionalFramework',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '创建机构'
    },
    hidden: true
  }, {
    label: '组织机构管理列表',
    icon: '',
    path: '/userList',
    name: 'userList',
    component: 'system/userList',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '组织机构管理列表'
    }
  }, {
    label: '组织机构管理列表',
    icon: '',
    path: '/adduser',
    name: 'adduser',
    component: 'system/adduser',
    meta: {
      isMenuOpens: '组织机构管理',
      title: '组织机构管理列表'
    },
    hidden: true
  },
  {
    label: '权限管理',
    icon: '',
    path: '/role',
    name: 'role',
    component: 'system/role',
    meta: {
      isMenuOpens: '系统管理',
      title: '权限列表'
    }
  },
  {
    label: '分组设置',
    icon: '',
    path: '/grouping',
    name: 'grouping',
    component: 'system/grouping',
    meta: {
      isMenuOpens: '系统管理',
      title: '分组设置'
    }
  },
  {
    label: '操作日志',
    icon: '',
    path: '/operationLog',
    name: 'operationLog',
    component: 'system/operationLog',
    meta: {
      isMenuOpens: '系统管理',
      title: '操作日志'
    }
  },
  {
    label: '系统人员权限',
    icon: '',
    path: '/personnelAccess',
    name: 'personnelAccess',
    component: 'system/personnelAccess',
    meta: {
      isMenuOpens: '系统管理',
      title: '系统人员权限'
    }
  },
  {
    label: '审批任务到期提醒',
    icon: '',
    path: '/smsAlert',
    name: 'smsAlert',
    component: 'system/smsAlert',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批任务到期提醒'
    }
  },
  {
    label: '审批流管理列表',
    icon: '',
    path: '/activitiList',
    name: 'activitiList',
    component: 'system/activitiList/index',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表'
    }
  }, {
    label: '审批流管理列表',
    icon: '',
    path: '/activitiDetails',
    name: 'activitiDetails',
    component: 'system/activitiList/activitiDetails',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表'
    },
    hidden: true
  }, {
    label: '审批流管理列表',
    icon: '',
    path: '/createActiviti',
    name: 'createActiviti',
    component: 'system/activitiList/createActiviti',
    meta: {
      isMenuOpens: '系统管理',
      title: '审批流列表',
      createActiviti: '1'
    },
    hidden: true
  }, {
    label: '我的任务',
    icon: '',
    path: '/myMission',
    name: 'newsList',
    component: 'myMission/index',
    meta: {
      isMenuOpens: '工作台',
      title: '我的任务'
    },
    hidden: true
  }, {
    label: '到期提醒设置',
    icon: '',
    path: '/RemindSet',
    name: 'RemindSet',
    component: 'system/RemindSet',
    meta: {
      isMenuOpens: '系统管理',
      title: '到期提醒设置'
    }
  }]
}]



// WEBPACK FOOTER //
// ./src/layout/menu.js